// cancel button
import { Link } from 'react-router-dom';

export default function IconLabel(props) {

  return (
  <>
    <div className="rounded-wd py-3 bg-wite hilite">
      
      <i className={`m-0 text-color-dark ${props.icon}`}  
        style={{fontSize:"2.4em", lineHeight:"0"}}>
      </i>
      
      <div className="">
        <p className={`m-0 pt-2 text-color-tone text-nowrap small`}>
        <small>{props.name}</small>
        </p>
      </div>

    </div>

  </>
  )
}